import { render, staticRenderFns } from "./MountPoint.vue?vue&type=template&id=5ad8df94"
var script = {}
import style0 from "./MountPoint.vue?vue&type=style&index=0&id=5ad8df94&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports